// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export const BASE_API_URL =
  import.meta.env.VITE_PROJECT_ENV === 'live'
    ? 'https://api.millwize.com/api'
    : 'http://127.0.0.1:8000/api';
//export const BASE_API_URL = 'https://api.millwize.com/api'
export const LOGIN = `/auth/login`
export const ME = `/auth/me`
export const EQUIPMENT_LIST = `/equipment`
export const INSERT_MASTER_SHEET = `/inspections`
export const GET_INSPECTION_DROPDOWN = `/inspections/user`
export const GET_INSPECTION = `/inspections`
export const GET_WEAR_SUMMARY= `/inspections/wear-summary`
export const GET_DASHBOARD= `/dashboard`
export const FORGOT_PASSWORD = `/forgot-password`
export const RESET_PASSWORD = `/reset-password`
export const UPLOAD_PDF_URL = `/upload-pdf`
export const DOWNLOAD_PDF_URL = `/download-zip-test/`
export const DELETE_INSPECTION = `/inspections/`
export const GET_USERS_ADMIN = `/admin/users-list`
export const UPDATE_USER_STATUS = `/admin/update-user-status/`
export const CREATE_USER = `/admin/register` //  api endpoint for creating user
export const UPDATE_USER_ACCESS = `/admin/users/limits/`
export const UPDATE_PROFILE = `/auth/profile/update`
//==========FRONTEND PAGE
export const MASTER_PAGE= `/dashboard/master-tab/`
